import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IHistoricalOrder } from '@rbi-ctg/menu';

import { ISelectedOrderState } from './selected-order.types';

export const initialState: ISelectedOrderState = {
  order: null,
};

export const selectedOrderSlice = createSlice({
  name: 'selectedOrder',
  initialState,
  reducers: {
    setSelectedOrder: (state, { payload }: PayloadAction<IHistoricalOrder | null>) => {
      state.order = payload;
    },
    clearSelectedOrder: state => {
      state.order = null;
    },
  },
});
